import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        formSubmission: '=',
        questions: '=',
        selectedLanguage: '=',
        showCorrectAnswers: '=',
        showAnswerFeedback: '=',
        showTesteesAnswers: '=',
        showQuestionFeedback: '=',
        showPointsAwarded: '='
    },
    template: `
        <div class="question theme02" ng-repeat="question in vm.questions">
           <quiz-question-radio
                is-trial="vm.isTrial"
                selected-language="vm.selectedLanguage"
                show-correct-answers="vm.showCorrectAnswers"
                show-answer-feedback="vm.showAnswerFeedback"
                show-testees-answers="vm.showTesteesAnswers"
                show-points-awarded="vm.showPointsAwarded"
                form-submission="vm.formSubmission"
                form="vm.form"
                question="question"
                ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.RADIO"
            />
            <quiz-question-checkbox
                is-trial="vm.isTrial"
                selected-language="vm.selectedLanguage"
                show-correct-answers="vm.showCorrectAnswers"
                show-answer-feedback="vm.showAnswerFeedback"
                show-testees-answers="vm.showTesteesAnswers"
                show-points-awarded="vm.showPointsAwarded"
                form-submission="vm.formSubmission"
                form="vm.form"
                question="question"
                ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX"
            />
           <quiz-question-free-text
                is-trial="vm.isTrial"
                selected-language="vm.selectedLanguage"
                show-correct-answers="vm.showCorrectAnswers"
                show-testees-answers="vm.showTesteesAnswers"
                show-points-awarded="vm.showPointsAwarded"
                form-submission="vm.formSubmission"
                form="vm.form"
                question="question"
                ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
            />
            <quiz-question-free-text-predefined
                is-trial="vm.isTrial"
                selected-language="vm.selectedLanguage"
                show-correct-answers="vm.showCorrectAnswers"
                show-testees-answers="vm.showTesteesAnswers"
                show-points-awarded="vm.showPointsAwarded"
                form-submission="vm.formSubmission"
                form="vm.form"
                question="question"
                ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT_PREDEFINED"
            />
           <quiz-question-hint
               is-trial="vm.isTrial"
               selected-language="vm.selectedLanguage"
               question="question"
               ng-if="(vm.formSubmission.occurrenceTraining.isHintingAllowed && question.activeI18n.hint) || (vm.isTrial && question.questionI18ns[vm.defaultLanguage].hint)"
           />
           <quiz-question-feedback
                ng-if="question.activeI18n.feedback && vm.showQuestionFeedback"
                feedback="question.activeI18n.feedback"
            />
        </div>
    `
})
export default class {
    constructor ($translate, TokenService, QUESTIONS_TYPE_ENUM) {
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.$translate = $translate;
        this.defaultLanguage = TokenService.getCompanyLanguage();
    }

    $onInit () {
        this.isTrial = this.formSubmission.isTrial;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/questions/index.js